module.exports = __webpack_public_path__ + "img/secalot.b8c54f82.svg";